import { DataOverview } from '@vwfs-bronson/bronson-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Contact } from 'cpie-common';
import { Notification, NotificationStatus } from '@cp-shared-15/frontend-ui';
import { ContactList } from './ContactList';

import { ErrorNotification } from '../../../notifications/error/ErrorNotification';
import { EditStatus } from '../EditStatus';

export type ConsultViewProps = {
    contact?: Contact;
    startEditing: () => void;
    lastEditStatus: EditStatus;
};

export const ConsultView: React.FC<ConsultViewProps> = ({ contact, startEditing, lastEditStatus }) => {
    const { t } = useTranslation('my-profile-contact-details');
    const { t: cms } = useTranslation('profile-cms');

    if (!contact) {
        return null;
    }

    const editButtonProps = {
        onClick: startEditing,
        secondary: true,
        icon: '',
        link: false,
        testId: 'edit-button',
        type: 'button' as const,
        element: 'button',
    };

    const notification =
        lastEditStatus === EditStatus.SUCCESS ? (
            <Notification
                status={NotificationStatus.warning}
                headline={t('edit-view.notification-success.headline')}
                testId={'success-notification'}
            >
                <strong>{t('edit-view.notification-success.text')}</strong>
            </Notification>
        ) : lastEditStatus === EditStatus.PHONE_VALIDATION_ERROR ? (
            <ErrorNotification
                text={
                    <span
                        dangerouslySetInnerHTML={{
                            __html: t('edit-view.notification-error.phone'),
                        }}
                    />
                }
                testId={'error-notification-phone'}
            />
        ) : (
            <ErrorNotification
                text={
                    <span
                        dangerouslySetInnerHTML={{
                            __html: t('edit-view.notification-error.text'),
                        }}
                    />
                }
                testId={'error-notification-text'}
            />
        );

    const notificationInfoText = (
        <span
            dangerouslySetInnerHTML={{
                __html: cms('consult-view.notification-info'),
            }}
        />
    );

    return (
        <DataOverview
            titleLevel={3}
            title={t('consult-view.title')}
            buttonLabel={t('translation:editable-section-nav.start')}
            href="#"
            buttonProps={editButtonProps}
        >
            <Notification status={NotificationStatus.info} className={`u-mb`}>
                {notificationInfoText}
            </Notification>
            <ContactList contact={contact} />
            {lastEditStatus !== EditStatus.NOT_PERFORMED && notification}
        </DataOverview>
    );
};
